import {
  AdgroupConfig,
  AdgroupFormData,
  BidStrategyType,
  CampaignFormData,
  VOStatusConfig,
  VOStatus,
  StrategyListItem,
} from '@tt4b/ttam-enums';
import { useAdgroupBidTypes, useStdAdgroupCbo, useStdAdgroupIs, isIncorrectRoasBid } from '@tt4b/ttam-hooks';
import { Ref, computed } from '@vue/composition-api';
import { i18n } from './../../../../i18n';

/** RoasCheckbox  */

export function useRoasCheckboxPropsVisible() {
  return {
    visible: (item: StrategyListItem) => item.type === BidStrategyType.HIGHEST_VALUE,
  };
}

export function useRoasCheckboxPropsDisabled(props: {
  voStatus: Ref<VOStatusConfig>;
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  adgroupConfig: Ref<AdgroupConfig>;
}) {
  const { voStatus, adgroupConfig, campaignData, adgroupData } = props;
  const { isCBOVO, isCBOVOHighestValue } = useStdAdgroupCbo({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });
  const isVOMinRoasSupport = computed(() => voStatus.value.roasStatus === VOStatus.QUALIFIED);
  const isVOHighestValueSupport = computed(() => voStatus.value.highestValueStatus === VOStatus.QUALIFIED);
  const disabled = computed(
    () =>
      adgroupConfig.value?.disableBidStrategy ||
      isCBOVO.value ||
      (isVOMinRoasSupport.value && !isVOHighestValueSupport.value),
  );
  const isVOHighestValueVisible = computed(() =>
    // CBO 优先保持和第一个一致
    isCBOVO.value ? isCBOVOHighestValue.value : isVOHighestValueSupport.value,
  );
  const isVOMinRoasVisble = computed(() =>
    // CBO 优先保持和第一个一致
    isCBOVO.value ? !isCBOVOHighestValue.value : isVOMinRoasSupport.value,
  );
  return {
    disabled,
    isVOHighestValueVisible,
    isVOMinRoasVisble,
  };
}

/** RoasTips  */
export function useRoasTipsPropsVisible(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  strategyList: Ref<StrategyListItem[]>;
}) {
  const { strategyList, adgroupData, campaignData } = props;
  const { isHighestValue } = useAdgroupBidTypes({
    strategyList,
    adgroupFormData: adgroupData,
  });
  const { isPSA } = useStdAdgroupIs({ campaignFormData: campaignData, adgroupFormData: adgroupData });

  const isCorrectRoasBid = computed(() => {
    const roasBid = adgroupData.value?.roasBid;
    return !isIncorrectRoasBid({ roasBid, isPSA: isPSA.value });
  });

  const visible = computed(() => isHighestValue.value && isCorrectRoasBid.value);

  return {
    visible,
  };
}

export function useRoasTipsPropsTips(props: { adgroupData: Ref<AdgroupFormData> }) {
  const { adgroupData } = props;
  const tips = computed(
    () =>
      (adgroupData.value?.roasBid
        ? (i18n.t('module_bid_roas_bid_info', { roas: adgroupData.value?.roasBid }) as string)
        : i18n.t('module_bid_roas_bid_hint')) as string,
  );

  return {
    tips,
  };
}
